import { render, staticRenderFns } from "./TicketPopup.vue?vue&type=template&id=46ef5ae5&scoped=true&"
import script from "./TicketPopup.vue?vue&type=script&lang=js&"
export * from "./TicketPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef5ae5",
  null
  
)

export default component.exports